import { IDeleteItemControleUseCase } from "../../../presentation/useCases/delete/delete_item_controle_use_case";
import { IEstoqueRepository } from "../../repositories/estoque_repository";

export class DeleteItemControleUseCase implements IDeleteItemControleUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async deleteItemControle(IdItemControleEstoque: number): Promise<void> {
    
    await this.repository.deleteItemControle(IdItemControleEstoque);
  }
}
